import React from 'react';
import '../styles/sections/headingWithIcons.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function HeadingWithIcons(props) {  
  const data = props.data;

  return (
    <div className="headingWithIcons">
        <div className="innerBox">    
        <h3 className="sectionHeading">{ data.title }</h3>
        {data.icons &&
          <ul className={data.columns === 4 ? 'fourCols' : ''}>
            {data.icons.map((d, i) => 
                <li key={i}> 
                  <img alt={ d.title } src={d.src}  />                                
                </li>
              )}   
          </ul>
        }
        {data.adaIcons && 
          <div className="ada-logos">
            {data.adaIcons.map((d,i)=>
              <LazyLoadImage
                key={i}
                alt={ d.title }
                effect="blur"
                src={d.src} 
              />
            )}            
          </div>
        }  
        </div>
    </div>
  )
};

export default HeadingWithIcons; 